export default __webpack_public_path__ + "static/media/sounds/fitb_practice_screen_ready_state.mp3";